import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { signIn } from "../../supabase/auth";
import AuthThemeToggle from "./AuthThemeToggle";
import "./Auth.css";
import "./Login.css";

function Login() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [status, setStatus] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        setStatus("Logging in...");

        const { data, error } = await signIn(email, password);

        if (error) {
            setStatus(`Error: ${error.message}`);
            setSubmitting(false);
            return;
        }

        const userEmail = data?.user?.email ?? email;
        setStatus("");
        setPassword("");

        navigate("/profile", {
            state: {
                email: userEmail,
            },
        });
        setSubmitting(false);
    };

    return (
        <main className="auth-page">
            <AuthThemeToggle />
            <div className="auth-shell">
                <section className="auth-left-panel">
                    <div className="auth-left-overlay" />
                    <div className="auth-left-content">
                        <img
                            src="/DribblLogo.jpg"
                            alt="Dribbl logo"
                            className="auth-left-logo"
                        />
                        <h1 className="auth-left-title">
                            The platform built for the game.
                        </h1>
                        <p className="auth-left-text">
                            Connect with athletes and coaches, share highlights, and build your football network.
                        </p>
                    </div>
                </section>

                <section className="auth-right-panel">
                    <section className="auth-card auth-card-login">
                        <div className="brand-header" />

                        <div className="auth-view-switch" role="tablist" aria-label="Authentication views">
                            <Link to="/login" className="auth-view-tab auth-view-tab-active" role="tab" aria-selected="true">Log In</Link>
                            <Link to="/signup" className="auth-view-tab" role="tab" aria-selected="false">Sign Up</Link>
                        </div>

                        <h1>Welcome back</h1>
                        <p className="auth-subtitle">Sign in to continue building your profile.</p>
                        <form className="form" onSubmit={handleSubmit}>
                            <label>
                                Email
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </label>

                            <label>
                                Password
                                <input
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </label>

                            <button type="submit" disabled={submitting}>{submitting ? "Logging in..." : "Log In"}</button>
                        </form>
                        {status && <p className="status-text">{status}</p>}

                        <p className="auth-subtext">
                            New to Dribbl? <Link to="/signup">Create an account</Link>
                        </p>
                    </section>
                </section>
            </div>
        </main>
    );
}

export default Login;
